import React from "react";
import { Button } from "react-bootstrap";
import { CrossIcon, EditIcon } from "../../icons/btnIcons";

const IconBtn = React.forwardRef(
  ({
    icon = null,
    variant = "outline-primary",
    isEdit = false,
    isDelete = false,
    isClose = false,
    className = "",
    iconSize = 16,
    children,
    ...rest
  }, ref) => (<Button
    ref={ref}
    variant={variant}
    {...rest}
    className={`ratio-1 lh-1 icon-btn ${className}`}
  >
    {isEdit && <EditIcon size={iconSize} />}
    {isClose && <CrossIcon size={iconSize} />}
    {icon}
    {children}
  </Button>)
);

export default IconBtn;
